import axios from 'axios';
import DocumentationIcon from '@material-ui/icons/HelpOutline';
import HomeIcon from '@material-ui/icons/Home';
import FinishIcon from '@material-ui/icons/Check';
import { Plugin } from 'tuc-webui-base/configuration';
import RouteService from 'tuc-webui-base/services/RouteService';
import { FormComponentInfo } from 'tuc-webui-base/components/FormViewComponent';
import {
  APP_MAIN_TYPE,
  APP_TOOLBAR_CONTENT_TYPE,
  FORM_VIEW_TYPE,
} from 'tuc-webui-base/services/ViewService';
import { TablePanelInfo, TableDateEditor } from './components/TablePanel';
import AppMain from './components/AppMain';
import TabsComponent from './components/TabsComponent';
import LayoutComponent from './components/LayoutComponent';
import fromConfiguration from './configuration/fromConfiguration';
import AppTitleBar from './components/AppTitleBar';
import { ObjectIdEditor } from './editors';
import {
  TABS_COMPONENT_TYPE,
  LAYOUT_COMPONENT_TYPE,
  TABLE_PANEL_TYPE,
} from './ComponentTypes';

export default class GrbPlugin extends Plugin {
  initialize(configuration) {
    const { jsonConfig } = configuration;
    const cfg = configuration;
    cfg.globalProps = jsonConfig.globalProps ? { ...jsonConfig.globalProps } : {};
    cfg.setApplicationTitle(jsonConfig.app.title);
    let { prefix } = jsonConfig;
    if (!prefix || prefix === '/') {
      prefix = '';
    } else if (prefix) {
      if (prefix[0] !== '/') {
        prefix = `/${prefix}`;
      }
      if (prefix[prefix.length - 1] === '/') {
        prefix = prefix.substring(0, prefix.length - 1);
      }
    }
    cfg.setPrefix(prefix);
    cfg.apiClientPrefix = `${configuration.schema.basePath}`;
    cfg.apiClient = axios.create({
      baseURL: cfg.apiClientPrefix,
    });
  }

  createServices(configuration, services) {
    Object.assign(this, services);
    return null;
  }

  registerComponents(viewService) {
    viewService.registerComponent(APP_MAIN_TYPE, AppMain);
    viewService.registerComponentInfo(TABLE_PANEL_TYPE, TablePanelInfo);
    viewService.registerComponent(TABS_COMPONENT_TYPE, TabsComponent);
    viewService.registerComponent(LAYOUT_COMPONENT_TYPE, LayoutComponent);
    viewService.registerViewComponent(FORM_VIEW_TYPE, FormComponentInfo);
    viewService.registerComponent(APP_TOOLBAR_CONTENT_TYPE, AppTitleBar);
  }

  registerEditors(viewService) {
    viewService.registerEditor('tableDate', new TableDateEditor());
    viewService.registerEditor('objectId', new ObjectIdEditor());
  }

  registerIcons(viewService) {
    viewService.registerIcon('Documentation', DocumentationIcon);
    viewService.registerIcon('Home', HomeIcon);
    viewService.registerIcon('Finish', FinishIcon);
  }

  createRouteService(configuration, props) {
    return new RouteService(configuration, props);
  }

  //
  // Process JSON config
  //

  getChildConfigurationKeys(cfg) {
    const info = cfg.type ? this.viewService.getComponentInfo(cfg.type) : null;
    if (info && info.getChildConfigurationKeys) {
      return info.getChildConfigurationKeys(cfg);
    }
    return ['components', 'component'];
  }

  initializeComponentConfiguration(cfg, ctx) {
    const component = typeof cfg === 'string' ? JSON.parse(JSON.stringify(ctx.sharedComponents[cfg])) : cfg;
    const info = this.viewService.getComponentInfo(component.type);
    const compCtx = {};
    if (info && info.initializeComponent) {
      info.initializeComponent(component, this, ctx, compCtx);
    }
    if (info && info.initializeConfiguration) {
      component.configuration = info.initializeConfiguration(component.configuration, this, compCtx);
    }
    const { data } = component;
    if (data) {
      this.viewService.initializeDataConfiguration(data);
    } else if (ctx.type && component.properties) {
      component.properties = this.viewService.initalizeDataProperties(component, ctx.type, true);
    }
    const childCtx = compCtx ? Object.assign({}, ctx, compCtx) : ctx;
    this.getChildConfigurationKeys(component).forEach((key) => {
      if (component[key]) {
        if (Array.isArray(component[key])) {
          component[key] = component[key].map(childCfg => this.initializeComponentConfiguration(childCfg, childCtx));
        } else {
          component[key] = this.initializeComponentConfiguration(component[key], childCtx);
        }
      }
    });
    return component;
  }

  initializeRouteConfiguration(routeCfg, ctx) {
    const mutRouteCfg = routeCfg;
    if (routeCfg.component) {
      mutRouteCfg.component = this.initializeComponentConfiguration(routeCfg.component, ctx);
    }
    if (!routeCfg.Main && mutRouteCfg.component) {
      mutRouteCfg.Main = fromConfiguration(mutRouteCfg.component);
    }
    if (routeCfg.children) {
      routeCfg.children.forEach(childCfg => this.initializeRouteConfiguration(childCfg, ctx));
    }
  }

  processJSONConfiguration(cfg) {
    let jsonConfig = cfg;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      // jsonConfig can be modified by some components
      // When running the webpack dev server and bringing modifications, the window.grbConfig is not updated
      // and thus leading components to be initialized on wrong config
      // For example, the GraphDashboard remove the defaults nodes from the config. After a reload
      // tile and actions provided with the defaults config are no more present
      console.log('Env', process.env.NODE_ENV);
      jsonConfig = JSON.parse(JSON.stringify(cfg));
    }
    const ctx = {
      jsonConfig,
      sharedComponents: jsonConfig.components || {},
    };
    jsonConfig.routes.forEach((routeCfg) => {
      this.initializeRouteConfiguration(routeCfg, ctx);
    });
    return jsonConfig;
  }
}
